module.exports = __webpack_public_path__ + "img/mmi-about-photo-04-mighty-minds-batch-of-scholars.4e6c44c9.png";